import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import useFetch from 'utils/hooks/useFetch';
import { ApiCheckAuth } from 'utils/constants/api';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'utils/context/AuthContext';

export default function MainContainer({ children }) {
	const { accessToken } = useAuth()
	const location = useLocation()

	const { fetch: checkAuth } = useFetch(ApiCheckAuth)
	
	let pathName = window.location.pathname
	let pathArray = pathName.split("/")

	const [isSidebarOpen, setIsSidebarOpen] = useState(localStorage.getItem("SidebarState") === "open" ? true : false);
	
	// useEffect(() => {
	// 	// fCheckAuth()
	// 	if (pathArray[1] !== "login" && pathArray[1] !== "tenant-registration"){
	// 		fCheckAuth()
	// 	}		
	// }, [])

	if (location.pathname === "/login") {
        return (
            <div className="overflow-hidden">
                <Outlet />
            </div>
        );
    }

	// Function Call API
	// async function fCheckAuth(){
	// 	if (localStorage.getItem("Token") === null){
	// 		window.location.href = "/login"
	// 	}else{
	// 		await checkAuth({
	// 			data: {}
	// 		}).then((response) => {
	// 			if(response.status === ApiResponseStatusUnauthorized){
	// 				window.location.href = "/login"
	// 			}
	// 		})
	// 	}
		
	// }

	function fToggleSidebar(state){
		if (state){
			localStorage.setItem("SidebarState", "close")
		}else{
			localStorage.setItem("SidebarState", "open")
		}

		setIsSidebarOpen(!state)
	}

	function fOnMobileToggleSidebar(){
		if (window.innerWidth < 720) {
			fToggleSidebar(isSidebarOpen)
		}
	}

	return (
		<div className="overflow-hidden h-screen w-full flex flex-col bg-black text-sm">
            <div className="sticky top-0 left-0 bottom-0 z-30 shadow-md">
                <Navbar
                    toggleSidebar={() => {
                        fToggleSidebar(isSidebarOpen);
                    }}
                />
            </div>

            <div className="w-full h-[calc(100vh-3.5rem)] overflow-hidden flex bg-white">

                <div className="sticky top-0 z-30">
                    <Sidebar
                        isOpen={isSidebarOpen}
                        onSidebarClick={() => {
                            fOnMobileToggleSidebar();
                        }}
                    />
                </div>

                <div className="w-full overflow-auto bg-white sm:bg-slate-50 text-sm">
                    <Outlet />
                </div>
            </div>
        </div>
	)
}
